import React from 'react';
import ReactDOM from 'react-dom/client';
import './app.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppNew } from './AppNew';
import { ErrorBoundary } from './components/ui/ErrorBoundary';

if (import.meta.env.DEV) {
  const __GLOBAL_REACT_KEY = '__BONGAI_REACT_INSTANCE__';
  const currentReact = (window as any)[__GLOBAL_REACT_KEY];
  if (currentReact && currentReact !== React) {
    console.error(
      '[BONG·AI] 检测到 React 多实例！这会导致 "Invalid hook call" 错误。\n' +
      '  已有实例:', currentReact.version, '\n' +
      '  新实例:', React.version, '\n' +
      '  请检查 vite.config.ts 的 alias/dedupe 配置，并清理 node_modules/.vite 缓存。'
    );
  } else if (!currentReact) {
    (window as any)[__GLOBAL_REACT_KEY] = React;
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <QueryClientProvider client={queryClient}>
    <ErrorBoundary>
      <AppNew />
    </ErrorBoundary>
  </QueryClientProvider>
);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      console.log('[SW] Registered:', reg.scope);
    }).catch((err) => {
      console.warn('[SW] Registration failed:', err);
    });
  });
}

// 生产环境：应用启动时预先 ping 后端，唤醒 Render 休眠服务
if (import.meta.env.PROD) {
  import('./config').then(({ API_BASE }) => {
    fetch(`${API_BASE}/api/models`).catch(() => {
      // 静默失败，不影响应用加载
    });
  });
}
